import { render, staticRenderFns } from "./official-document-add.view.vue?vue&type=template&id=2d8589be&"
import script from "./official-document-add.view.vue?vue&type=script&lang=ts&"
export * from "./official-document-add.view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports